module.exports = __webpack_public_path__ + "static/team1-7801c551f28ce4b278b1bb828426b06b.jpg";